import { TokenPayload } from "../models/IToken";
import TokenService from "./token.service";
export class UACService {

    static async checkCompatibility(): Promise<boolean> {
        const isUACSession = this.getUACFlagFromToken();
        if (!isUACSession) {
            return true;
        }

        const userIsAdmin = await (window as any).electronAPI.checkAdminPrivileges();
        return Boolean(userIsAdmin);
    }

    private static getUACFlagFromToken(): boolean {
        const parsedToken: TokenPayload = TokenService.parseToken(true, "");
        try {
            const meta = JSON.parse(parsedToken.metadata);
            return Boolean(meta.isUACBasedAccessSession);
        } catch {
            return false;
        }
    }
}
